<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="content p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <form [formGroup]="formGroup">
        <mat-form-field class="w-100-p">
            <mat-label>{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.ADD_CERTIFICATE_TEMPLATE_TO_MODULE.LABELS.CERTIFICATE_NAME' | translate }}</mat-label>
            <input matInput type="text" formControlName="name" />
            <mat-error *ngIf="formGroup.controls.name.errors && !formGroup.controls.name.hasError('required')">{{
                'ERROR.RESPONSE.' + formGroup.controls.name.errors['message'] | translate
            }}</mat-error>
        </mat-form-field>

        <mat-form-field class="mt-16 w-100-p">
            <input matInput type="number" min="1" placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.TARGET_CERTIFICATION_COUNT' | translate }}" formControlName="targetCtrl" />
        </mat-form-field>

        <div class="bg-lightgreybackground p-24 rounded-s">
            <mat-slide-toggle [formControl]="validityCtrl">
                <h3>{{ 'GENERAL.LABEL.CERTIFICATE_VALIDITY' | translate }}</h3>
            </mat-slide-toggle>
            <mat-form-field class="w-100-p mt-16" *ngIf="validityCtrl.value">
                <mat-label>{{ 'GENERAL.PROPERTY.NUMBER_OF_MONTHS' | translate }}</mat-label>
                <input matInput type="number" formControlName="validityPeriod" />
            </mat-form-field>
        </div>
    </form>
    <p class="title mb-12">{{ 'COURSE_OFFERING.LABEL.TEMPLATE' | translate }} *</p>
    <div class="p-16 bg-lightgreybackground">
        <div
            *ngIf="!uploadedCertificateFiles.length; else fileAdded"
            class="file-drop-container certificates-list"
            cdkDropList
            (drop)="onFileDropped($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            [class.drag-over]="isDragOver"
        >
            <div>
                <div fxLayout="column" fxLayoutAlign="center center">
                    <app-white-button class="my-12" [label]="'CONTENT.BUTTON.UPLOAD'" (onClick)="fileInput.click()" [showThreeDots]="true"></app-white-button>
                    <input
                        class="bg-white rounded-sm p-8 pointer border border-gray-300"
                        type="file"
                        style="display: none"
                        (change)="fileChange($event.target.files)"
                        [placeholder]="'CONTENT.BUTTON.UPLOAD' | translate"
                        accept=".docx"
                        #fileInput
                    />
                    <p>{{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.ADD_CERTIFICATE_TEMPLATE_TO_MODULE.LABELS.OR_DRAG_AND_DROP' | translate }}</p>
                </div>
            </div>
        </div>
        <ng-template #fileAdded>
            <mat-card appearance="outlined">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="mr-8">description</mat-icon>
                        <span>{{ uploadedCertificateFiles[0].name }}</span>
                    </div>
                    <mat-icon class="pointer" (click)="onRemoveAddedCertificate()">close</mat-icon>
                </div>
            </mat-card>
        </ng-template>
        <div class="mt-24">
            <div fxLayoutAlign="space-between center">
                <p>{{ 'GENERAL.LABEL.KEYWORDS_YOU_CAN_USE_IN_YOUR_CERTIFICATE' | translate }}:</p>

                <app-white-button
                    [label]="'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.ADD_CERTIFICATE_TEMPLATE_TO_MODULE.BUTTON.DOWNLOAD_EXAMPLE_CERTIFICATE'"
                    (onClick)="downloadFile()"
                ></app-white-button>
            </div>
            <div class="keywords-wrapper mb-32">
                <div class="keyword-tag pointer" *ngFor="let keyword of certificateKeywords" (click)="copyKeywordToClipboard(keyword)">
                    <span>{{ keyword }}</span>
                    <mat-icon svgIcon="keyword_tag"></mat-icon>
                </div>
            </div>
            <ng-container *ngIf="!certificateKeywords?.length">
                <div class="white" fxLayout="column" fxLayoutAlign="center center">
                    <div>
                        <mat-spinner diameter="24"></mat-spinner>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        (onClick)="onAddCertificates()"
        [label]="'GENERAL.BUTTON.SAVE'"
        [isLoading]="isAddingCertificate"
        [disabled]="
            isAddingCertificate ||
            (isEditMode ? !formChanged() : !formGroup.valid || !uploadedCertificateFiles.length || (validityCtrl.value && !formGroup.get('validityPeriod').value))
        "
    ></app-flat-button>
</div>
